module.exports = {"OrderQueue":"Tilaukset","InProgress":"Työn alla","OrdersInProgress":"Työn alla","Ready":"Valmiina noudettavaksi","OrdersReady":"Valmiina noudettavaksi","DisplaySettings":"Näyttöasetukset","Cancel":"Peruuta","Save":"Tallenna","kitchenServiceAddress":"Keittiöpalvelun osoite","UnexpectedPosError":"Odottamaton virhe! Tarkista yhteys!","CheckConnection":"Yhteys Keittiöpalveluun epäonnistui. Tarkista asetukset!","Refresh":"Päivitä","showReadyToPickUpView":"Näytä Valmis noudettavaksi","showPreparationView":"Näytä Työn alla"}


//////////////////
// WEBPACK FOOTER
// ./src/translations/fi.json
// module id = 245
// module chunks = 0